// Builds the inspect popup HTML from queried features. Ported from the 1.0
// viewer's MapUtils.renderPopup, adapted to the engine's QueriedFeature shape.
// Pure string builder — no DOM, no renderer dependency.

import type { QueriedFeature } from "../types";

function escapeHtml(value: unknown): string {
    const s = value === null || value === undefined ? "" : String(value);
    return s
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}

function renderProperty(name: string, value: unknown): string {
    return (
        '<div class="mbview_property">' +
        `<div class="mbview_property-name">${escapeHtml(name)}</div>` +
        `<div class="mbview_property-value">${escapeHtml(value)}</div>` +
        "</div>"
    );
}

function renderFeature(feature: QueriedFeature): string {
    const header =
        `<div class="mbview_layer">${escapeHtml(feature.sourceLayer ?? feature.source)}</div>` +
        renderProperty("$type", feature.geometryType) +
        (feature.id !== undefined ? renderProperty("$id", feature.id) : "");

    const props = Object.keys(feature.properties ?? {})
        .map((key) => renderProperty(key, feature.properties[key]))
        .join("");

    const meta =
        renderProperty("Source Layer", feature.sourceLayer ?? feature.source) +
        renderProperty("Layer Id", feature.layerId);

    return `<div class="mbview_feature">${header}${props}${meta}</div>`;
}

/** Renders the popup body for a set of inspected features. */
export function renderFeaturePopup(features: QueriedFeature[]): string {
    return `<div class="mbview_popup">${features.map(renderFeature).join("")}</div>`;
}
